import { render } from "./PerjanjianKinerjaBalai.vue?vue&type=template&id=100b032d"
import script from "./PerjanjianKinerjaBalai.vue?vue&type=script&lang=js"
export * from "./PerjanjianKinerjaBalai.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__